import type { NskResponse } from '~/models/Api';
import { postRequest } from '~/utils/api/api_handler';

const paths = {
  create: '/deals/:deal_id/deal_cancel_backs'
};
export const create = async (dealId: number): Promise<NskResponse<void>> =>
  postRequest(paths.create.replace(':deal_id', String(dealId)));
